export const EVENT_NAME = {
  PILL_CLICKED: "Pill Selected",
  CAROUSEL_SELECTED: "Tutorial Selected",
  ARTICLE_SELECTED: "Education Article Selected",
  ARTICLE_VIEWED: "Education Article Viewed"
};
